<template>
    <div id="app" class="fp-offers">
        <!-- access root props via $root -->
        <div v-for="offer in offers" class="card">
            <div class="header" :style="{background: offer.feed.color}">
                <div class="title">{{ offer.title }}</div>
                <img :src="offer.feed.logo_url" :alt="offer.feed.name" class="logo" width="40" height="40"/>
            </div>
            <div class="body">
                <div class="description" v-html="offer.description">
                </div>

                <a :href="offer.link" class="link" :style="{background: offer.feed.color}">
                    {{ offer.button_text }} »
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['url', 'feed', 'offer'],
        data() {
            return {
                offers: []
            }
        },
        mounted() {
            let params = {};

            if (this.$root.feed > 0) {
                params.feed_id = this.$root.feed;
            }

            if (this.$root.offer > 0) {
                params.offer_id = this.$root.offer;
            }

            const urlParams = new URLSearchParams(params);

            fetch(this.$root.url + '?' + urlParams.toString(), {
                method: 'GET'
            }).then((response) => {
                return response.json();
            }).then((offers) => {
                this.offers = offers;
            });
        },
        /*methods: {
            span(text) {
                return `<span> ${text} </span>`
            }
        }*/
    }
</script>

<style scoped>
    .card {
        margin: 0 auto 1.5rem;
        max-width: 500px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
        font-size: 20px;
        background: #fff;
    }

    .header {
        color: #fff;
        display: flex;
        align-items: center;
        padding: 4px 4px 4px 10px;
        font-weight: 500;
    }

    .title {
        flex: 1;
        padding-right: 7px;
    }

    .description {
        font-size: 14px;
    }

    .body {
        padding: 10px;
    }

    .link {
        display: block;
        color: #fff;
        text-align: center;
        padding: 6px;
        text-decoration: none;
        font-weight: bold;
        margin-top: 10px;
        opacity: 0.8;
    }

    .link:hover {
        opacity: 1;
        text-decoration: none;
    }
</style>
